<template>
  <div class="blog-user-index mb-3 col-sm-12 col-12 mx-0 px-0 pt-3" v-if="data.id">
    <div v-show="data.bloggerinfo_bloggerID" class="user-bg d-flex" v-bind:style="{backgroundImage:'url('+data.bloggerinfo_bloggerID.background+')',backgroundSize:'cover'}">
      <div class="user-bgup flex-fill">
        <span class="name" slot="reference">{{data.bloggerinfo_bloggerID.name}}</span>

        <p class="bdescription" v-html="data.bloggerinfo_bloggerID.description"></p>
      </div>
      <div class="pr-3 pt-auto" style="position:absolute;right:10px;top:10px" v-if="data.id==$store.state.user.userinfo.UserID">
        <el-popover
            placement="bottom-end"
            ref="blog_home_setting"
            v-model="bubbles.blog_home_setting"
            width="300"
            popper-class="bubble"
            trigger="manual"
        >
          <p v-if="user.userinfo.bubble">{{user.userinfo.bubble.instruction.blog_home_setting}}</p>
          <div style="text-align: right; margin: 0">
            3/3
            <el-button class="ml-3" type="primary" round size="mini" @click="removeBubble('blog_home_setting')">{{$t('message').userindex.bubble_iknow}}</el-button>
          </div>
          <n-button v-if="data.bloggerID!==0" @click="$router.push('/profile/?id=0')" size="sm" slot="reference"><span class="d-none d-sm-block">{{$t('message').setting.menu_bolg}}</span><i class="el-icon-setting d-sm-none"></i></n-button>
        </el-popover>
        <el-button v-if="data.bloggerID==0"  type="primary" @click="$router.push('/blog_register')">{{$t('message').setting.blogregist_btn}}</el-button>
      </div>
    </div>
    <div class="user-avatar d-flex py-2">
      <div class="avatarbox" @click="go()">
        <icon-V class="vip mr-2 text-primary lable" v-if="data.userinfo_id.is_hot_blogger">
        </icon-V>
        <div
            v-if="!data.userinfo_id.avatar"
            class="avatar-word" :style="{height:'100px',width:'100px',lineHeight:'100px'}">{{data.userinfo_id.first_letter}}</div>
        <img
            v-if="data.userinfo_id.avatar"
            :src="data.userinfo_id.avatar"
            :alt="data.userinfo_id.username">

      </div>
      <div class="flex-fill">
        <div class="row textgroup">
                    <span class="col-auto mr-1 blog-user-index-des name">
                    {{data.userinfo_id.username}}</span>
          <!--          <el-tooltip effect="light" :content="getCountryName()" placement="top" visible-arrow="false">-->
          <!--            <a style="font-size:41px;margin-right:10px;text-decoration: none;cursor: pointer">{{data.userinfo_id.country_flag.flag}}</a>-->
          <!--          </el-tooltip>-->
          <span class="col-9 blog-user-index-des x ml-3">{{data.userinfo_id.description}} </span>
        </div>
        <span v-if="data.bloggerID" class="blog-user-index-des mr-4">
                    {{$t('message').userindex.header_readcount}}{{data.bloggerinfo_bloggerID.count_read}}</span>
        <!--        <span class="blog-user-index-des mr-2">-->
        <!--                    {{$t('message').userindex.header_funs}}{{data.userinfo_id.count_follower}}</span>-->
        <!-- share -->
        <el-popover
            placement="top-end"
            trigger="click"
            v-model="share.showShareBar">
          <el-popover style="display:inline-block"
                      placement="bottom-end"
                      width="400"
                      trigger="click"
                      visible-arrow="false"
                      v-model="share.wechatQR">
            <div class="float-right" @click="share.wechatQR=false">{{$t('message').article.share_wechat_close}}</div>
            <div class="mt-5">{{$t('message').article.share_wechat_text}}</div>
            <img style="margin: 0 95px;" :src="shareItem.QRcode" alt="">
            <a href="#" @click="share.showShareBar=false" slot="reference">
              <span class="shareIcon  d-sm-block" v-html="icons.wechat"></span>
            </a>
          </el-popover>
          <div class="ml-2 shareIcons" style="display:inline">
            <ShareNetwork
                v-for="item in shareNetworks"
                :key="item.network"
                :network="item.network"
                :url="shareItem.url"
                :title="shareItem.title"
                :description="shareItem.description"
                quote=""
                hashtags=""
            >
              <span class="shareIcon mr-1" v-html="item.icon" @click="share.showShareBar=false"></span>
            </ShareNetwork>

            <a class="btn bg-white btn-info  p-1 ml-2 mr-0" href="#" role="button" @click="copyUrl()">
              <span v-html="icons.copy"></span>
            </a>
          </div>
          <button type="button" class="btn btn-icon btn-round btn-neutral" :title="$t('message').article.share_text" slot="reference">
            <span style=" fill:#39B8EB;" v-html="icons.share"></span>
          </button>
        </el-popover>
        <span class="blog-user-index-des mr-2">分享此博客</span>
        <div  v-if="!$store.state.user.check_is_wxcblog_domain()" class="float-right pr-4 qqh">
          <n-button
              link
              size="sm"
              @click="openModal()"
          >
            <icon-mail style="width:25px;fill:#39b8eb"></icon-mail> <span style="color:#39b8eb;font-size:1rem;">{{$t('message').qqh.btn_send}}</span>
          </n-button>

          <n-button
              :type="data.userinfo_id.is_following?'text':'primary'"
              round
              size="sm"
              @click="follow"
              class="editbtn ml-3"
          >
            <icon-plus :style="{fill:'#fff'}"></icon-plus>{{data.userinfo_id.is_following?$t('message').blog.blogger_followed:$t('message').blog.blogger_follow}}
          </n-button>
        </div>
      </div>
      <div class="pr-3" v-if="data.id==$store.state.user.userinfo.UserID">
        <el-popover
            placement="bottom-end"
            ref="blog_home_profile"
            v-model="bubbles.blog_home_profile"
            width="300"
            popper-class="bubble"
            trigger="manual"
        >
          <p v-if="user.userinfo.bubble">{{user.userinfo.bubble.instruction.blog_home_profile}}</p>
          <div style="text-align: right; margin: 0">
            2/3
            <el-button class="ml-3" type="primary" round size="mini" @click="removeBubble('blog_home_profile')">{{$t('message').userindex.bubble_iknow}}</el-button>
          </div>
          <n-button size="sm" @click="$router.push('/profile/?id=1')" slot="reference">
            <span class="d-none d-sm-block">{{$t('message').setting.menu_accout}}</span>
            <i class="el-icon-setting d-sm-none"></i>
          </n-button>
        </el-popover>
      </div>

    </div>

    <!-- Send QQH Modal -->
    <modal :show.sync="modals.sendQqhModal" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up" style="padding-top:5px">{{$t('message').qqh.modal_title_prefix}} {{data.userinfo_id.username}} {{$t('message').qqh.modal_title}}</h4>

      <div class="datepicker-container d-flex justify-content-center">
        <el-input
            type="textarea"
            :rows="3"
            :placeholder="$t('message').qqh.modal_placeholder"
            v-model="modals.qqhMsgbody">
        </el-input>
      </div>

      <template slot="footer">
<!--        <span v-if="modals.modalData" :class="{'text-success':modals.modalData.status,'text-danger':!modals.modalData.status,}">{{modals.modalData.status?$t('message').qqh.modal_succese:modals.modalData.error}}</span>-->
        <n-button
            class="mr-3"
            type="default"
            link
            @click.native="modals.sendQqhModal = false"
        >
          {{$t('message').qqh.modal_btn_cancel}}
        </n-button>
        <n-button
            type="primary"
            round
            simple
            @click.native="sendQqh(data)"
        >
          {{$t('message').qqh.modal_btn_send}}
        </n-button>
      </template>
    </modal>
    <login-dialog ref="dialog"></login-dialog>
  </div>
</template>
<script>
import {
  IconMail,
  IconPlus,
  IconV
} from '@/components/Icons';
import {
  Button,
  Modal,
} from '@/components';
import { Input } from 'element-ui';
import icons from "@/components/Icons/Icons";
import blog from '../blog.service';
import account from '../../user/user.service';
import LoginDialog from '../../user/login/LoginDialog';
export default {
  name: 'blog-user-index-header',
  props:{
    info:Object
  },
  watch:{
    'info' : function(val){
      this.data = val;
      this.init_data(val);
    },
  },
  components:{
    IconMail,
    IconPlus,
    IconV,
    [Button.name]: Button,
    [Input.name]: Input,
    Modal,
    LoginDialog
  },
  beforeMount:function(){
    this.init_data(this.data);
  },
  mounted() {
    this.showBubble();
  },
  methods:{
    // getInfo(){
    //     blog.blogger_info(this.bloggerID).then(res=>{
    //         this.data = res.data;
    //         this.data.bloggerinfo_bloggerID.background = this.data.bloggerinfo_bloggerID.background?this.data.bloggerinfo_bloggerID.background:this.defaultBackground;
    //     })
    // },
    init_data(data){
      if(!data.bloggerID){
        this.data.bloggerID = 0 ;
        this.data.bloggerinfo_bloggerID = this.default_blginfo;
      }

    },
    openModal(){
      if(this.$store.state.user.userinfo.UserID!==undefined){
        this.modals.sendQqhModal=true
      }else{
        this.$refs.dialog.isLogin()
      }
    },
    sendQqh(data){
      this.send(data.id,this.modals.qqhMsgbody);
    },
    async send(touserID,msgbody) {
      let user = this.$store.state.user;
      let res = await user.sendQqh(touserID,msgbody);

      setTimeout(()=>{
        this.modals.modalData=undefined;
        this.modals.sendQqhModal=res.status?false:true;
      },4);
      if (res.status) {
        this.$message.success("您的悄悄话已发送！");
      }
      else {
        this.$message.warning(res.error);
      }

    },
    go(){
      let url=this.$route.path
      let isidx = url.indexOf('blog/user')
      if(isidx==-1){
        this.$router.push('/blog/user/' + this.$store.state.user.userinfo.id);
      }
    },
    following_add(id){
      if(this.$store.state.user.userinfo.UserID!==undefined){
        account.following_add(id).then(res=>{
          if(res.status) {
            this.data.userinfo_id.is_following = 1;
          }else{
            this.$message.error(res.error);
          }
        });
      }else{
        this.$refs.dialog.isLogin()
      }
    },
    following_delete(id){
      if(this.$store.state.user.userinfo.UserID!==undefined){
        account.following_delete(id).then(res=>{
          if(res.status == true) {
            this.data.userinfo_id.is_following = 0;
          }else{
            this.$message.error(res.error);
          }
        });
      }
    },
    follow(){
      if(this.data.userinfo_id.is_following){
        this.following_delete(this.data.id)
      }else{
        this.following_add(this.data.id)
      }
    },
    showBubble(){
      var bubbles=['blog_home_manage','blog_home_profile','blog_home_setting'];
      if(this.user.userinfo.bubble){
        for(let i=0;i<bubbles.length;i++){
          let type = bubbles[i]
          if(this.user.userinfo.bubble.user[type]==1 && this.user.userinfo.UserID==this.data.id){
            this.bubbles[type]=true;
            return
          }else{
            this.bubbles[type]=false;
          }
        };
      }

    },
    removeBubble(type){
      this.user.remove_bubble(type).then(res=>{
        if(res.status){
          this.user.userinfo.bubble = res.data;
          this.showBubble();
        }
      })
    },
    copyUrl() {
      var oInput = document.createElement("input"); //创建隐形input
      oInput.value = window.location.href; // window.location.href 浏览器URL
      document.body.appendChild(oInput);
      oInput.select();
      document.execCommand("Copy");
      oInput.remove();
      this.$message.success("本文链接已复制成功！");
      this.share.showShareBar=false;
    },
    getCountryName(){
      return localStorage.lang === 'cns'?this.info.userinfo_id.country_flag.cns:this.info.userinfo_id.country_flag.cnt
    }
  },
  data() {
    return {
      user:this.$store.state.user,
      default_blginfo:{
        background : '/img/default_bg.jpg',
        name : this.$t('message').userindex.name_noregist,
        description : this.$t('message').userindex.discrib_noregist},
      data:this.info,
      icons:icons,
      modals:{
        sendQqhModal:false,
        qqhMsgbody:'',
        modalData:undefined
      },
      share:{
        showShareBar:false,
        wechatQR:false
      },
      shareItem:{
        url:window.location.href,
        title:'',
        description:'',
        QRcode:'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data='+window.location.href
      },
      shareNetworks:[
        {
          network:'facebook',
          icon:icons.facebook
        },{
          network:'twitter',
          icon:icons.twitter
        },{
          network:'line',
          icon:icons.line
        },{
          network:'whatsapp',
          icon:icons.whatsapp
        },{
          network:'weibo',
          icon:icons.weibo
        }
      ],
      bubbles:{
        blog_home_manage:false,
        blog_home_profile:false,
        blog_home_setting:false
      }
    };
  },
}
</script>
<style>
.shareIcons a:hover{
  text-decoration: none;
}
.shareIcon svg{
  width:28px;
  height:28px;
}
.blog-user-index .user-bg{
  background-size:cover;
  background-position-y: center;
  background-color: #fbfbfb
}
.blog-user-index .user-bgup{
  height:230px;
  padding: 106px 30px 0 165px;
  background: -webkit-linear-gradient(top, rgba(0,0,0,0) 50%,rgba(0,0,0,0.3) 100%);
  background: linear-gradient(to bottom, rgba(0,0,0,0) 50%,rgba(0,0,0,0.3) 100%)
}
.blog-user-index .user-bgup .name{
  font-size:1.6rem;
  padding: 6px 0;
  color:white;
  text-shadow: 1px 1px 0 #0000000f,
  -1px 1px 0 #0000000f,
  1px -1px 0 #0000000f,
  -1px -1px 0 #0000000f,
  0px 1px 0 #0000000f,
  0px -1px 0 #0000000f,
  -1px 0px 0 #0000000f,
  1px 0px 0 #0000000f,
  2px 2px 0 #0000000f,
  -2px 2px 0 #0000000f,
  2px -2px 0 #0000000f,
  -2px -2px 0 #0000000f,
  0px 2px 0 #0000000f,
  0px -2px 0 #0000000f,
  -2px 0px 0 #0000000f,
  2px 0px 0 #0000000f,
  1px 2px 0 #0000000f,
  -1px 2px 0 #0000000f,
  1px -2px 0 #0000000f,
  -1px -2px 0 #0000000f,
  2px 1px 0 #0000000f,
  -2px 1px 0 #0000000f,
  2px -1px 0 #0000000f,
  -2px -1px 0 #0000000f;
}
.blog-user-index .user-avatar{
  background-color: #f6f6f6;
}
.blog-user-index .user-avatar img,
.blog-user-index .avatar-word{
  min-width: 100px;
  width:100px;
  height: 100px;
  /*margin: -62px 10px 10px 10px;*/
  margin: -3px 10px 10px 10px;
  border:2px white solid;
  border-radius: 50%;
}
.blog-user-index .blog-user-index-name{
  font-size: 1.125rem;
  font-weight: 700;
  text-align:center
}
.blog-user-index .bdescription{
  font-size: 19px;
  color: #fff;
  text-shadow: 0 0 4px rgb(0 0 0 / 50%);
  font-weight: 500;
  line-height: 26px;
}
.blog-user-index .blog-user-index-des{
  font-size: 1rem;
  color: gray;
  display: inline-block;
  margin-top: 11px;
}
.blog-user-index .blog-user-index-des.x{
  margin: 15px 15px 15px 0;
  color: #647685;
  font-size: 1.1rem;
  padding-left:0;
}
.blog-user-index .blog-user-index-des.name{
  font-size: 1.4rem;
  color:black;
  padding-right: 0;
  font-weight:400;
  margin:12px 0 12px 0
}
.blog-user-index .avatar-word{
  background-color: aliceblue;
  text-align: center;
  font-weight: 500;
  font-size: 36px;
  line-height: 90px;
}
.el-popover.bubble {
  background-color: #14171a;
  color:white
}
.el-popover.bubble .popper__arrow,
.el-popover.bubble .popper__arrow::after{
  border-top-color: #14171a;
  border-bottom-color: #14171a;
}
.el-tooltip__popper .popper__arrow,.el-tooltip__popper .popper__arrow::after{
  display: none;
}
.el-tooltip__popper, .tooltip-inner{
  min-width: 32px !important;
}
.blog-user-index .el-avatar{
  border: 2px solid white
}
.blog-user-index .btn-neutral {
  background-color: #f6f6f6;
}
.vip {
  position: absolute;
  font-size: 46px;
  margin-left: 88px;
  margin-top: -8px;
  margin-top: -6px;
  -webkit-transform: rotate(40deg);
  transform: rotate(43deg);
  text-decoration: none;
  cursor: pointer;
}


/*.vip{*/
/*  position:absolute;*/
/*  font-size:42px;margin-left:126px;*/
/*  margin-top:-65px;*/
/*  transform: rotate(40deg);*/
/*  text-decoration: none;cursor: pointer*/
/*}*/
@media (max-width: 767.98px) {
  .blog-user-index .bdescription,
  .blog-user-index .blog-user-index-des.x{
    display:none
  }
  .blog-user-index .user-bgup {
    background: no-repeat;
    padding: 20px 10px;
    height: 20vw;
  }
  .blog-user-index.user-bg.d-flex{
    background-image: no;
  }
  .blog-user-index .qqh {
    margin: 10px;
    width: 100%;
    float: left
  }
  .blog-user-index .user-avatar img,
  .blog-user-index .avatar-word{
    min-width: 60px;
    width:60px;
    height: 60px;
    margin: -7px 10px 10px 10px;
    border:2px white solid;
    border-radius: 50%;
  }
  .blog-user-index .editbtn {
    border-color: #888888e6!important;
  }
  .blog-user-index  .row.textgroup{
    flex-wrap: inherit
  }
  .blog-user-index{
    padding: 0 !important;
  }
  .blog-user-index .btn-neutral {
    background-color: #F6F6F6!important
  }
  .blog-user-index .vip{
    position:absolute;
    font-size:42px;
    margin-left:53px;
    margin-top:-17px;
    transform: rotate(45deg);
    text-decoration: none;
    cursor: pointer
  }
}
</style>